export default __webpack_public_path__ + "static/0169-b2d62857fd5ed3c46f9990d68ea41818.png";